import { Component, Input } from '@angular/core';
import { INotesTableData } from '@modeso/aumico-lib-annualreport-fe';
import { IPrintOptions } from '@modeso/types__aumico-lib-annualreport-be';

@Component({
    selector: 'aumico-notes-equity-display',
    templateUrl: './notes-equity-display.component.html',
    styleUrls: ['./notes-equity-display.component.scss'],
})
export class NotesEquityDisplayComponent {
    @Input() set sectionNotes(value: INotesTableData[]) {
        this.sectionData = value;
    }
    @Input() set printOptionStyles(value: IPrintOptions | undefined) {
        if (value != null) {
            this.textColor = value.styleOptions.textColor;
            this.backgroundColor = value.styleOptions.backgroundColor;
            this.tableHeaderColor = value.styleOptions.tableHeaderColor;
            this.tableFooterColor = value.styleOptions.tableFooterColor;
            this.backgroundColorPY = value.styleOptions.backgroundColorPY;
        }
    }
    @Input() noPreviousData: boolean;

    textColor: string;
    backgroundColor: string;
    backgroundColorPY: string;
    tableFooterColor: string;
    tableHeaderColor: string;
    public sectionData: INotesTableData[];
    constructor() {}
}
